import type { CandidateRelationView } from '../types';

export const PROJECT_GRAPH_CONNECTED_QUERY_KEY = 'projectGraphConnected';

/**
 * The React Query key for a candidate relation's connected-nodes fetch (a single capped page — see
 * `CONNECTED_NODES_PAGE_SIZE`). Shared between `loadRelationMembers` (the real fetch) and
 * `probeRelationHasMembers` (a cheap "does this relation have any members" check) so that probing a
 * relation warms the exact cache entry the real reveal will look up, instead of the two silently
 * drifting apart and fetching the same page twice.
 *
 * Not to be shared with a *list* surface over the same endpoint (`useConnectedDataNodes`). This entry
 * holds a bare `DataNode[]`; an infinite query holds `InfiniteData<DataNode[]>`, so merging the keys
 * would have the two overwrite each other with structurally different values — a runtime fault
 * TypeScript wouldn't catch.
 */
export function connectedNodesQueryKey(
  projectId: string,
  proposalId: string | undefined,
  parentId: string,
  relation: CandidateRelationView
) {
  return [
    PROJECT_GRAPH_CONNECTED_QUERY_KEY,
    projectId,
    proposalId,
    parentId,
    relation.relationId,
    relation.connectedType.technicalName,
    relation.isReverse
  ] as const;
}
